// OutOfDateIcon - small clock beside a filename on the Files tab, for an upload
// an operator has marked out of date.
//
// Purely visual: clicking does nothing. Hover tooltip explains
// what the icon means. Sized to sit inline next to text without
// disrupting line height.
import { Tooltip } from "./Tooltip";

interface Props {
  // Override the default tooltip with the file's own detail.
  tooltip?: string;
  // Pixel size. Defaults to 14 - sits cleanly next to 13-14px
  // body text. Bump to 16 for headings.
  size?: number;
  // Whether the icon sits to the left or right of the text it annotates.
  position?: "left" | "right";
}

export const OutOfDateIcon = ({
  tooltip = "Marked out of date by an operator. The file still exists; this flags it as a stale revision.",
  size = 14,
  position = "right",
}: Props): JSX.Element => (
  <Tooltip content={tooltip}>
    <span
      aria-label="Out of date"
      style={{
        display: "inline-flex",
        alignItems: "center",
        marginLeft: position === "right" ? 6 : 0,
        marginRight: position === "left" ? 6 : 0,
        color: "#b45309",
        lineHeight: 1,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        style={{ display: "block" }}
      >
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    </span>
  </Tooltip>
);
